import Vue from 'vue'
import VueRouter from 'vue-router'
import OrderDetail from '@/components/store/order/orderDetail.vue'
import ShipTable from '@/components/store/order/shipTable.vue'

import RefundDetail from '@/components/store/order/refundDetail.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
	meta: {
	  isLogin: false,
	},
    component: () => import('../views/Login.vue')
  },
  {
    path: '/index',
    name: 'index',
	meta: {
	  isLogin: true, // 添加该字段，表示进入这个路由是需要登录的
	},
    component: () => import('../views/Home.vue')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
  	meta: {
  	  isLogin: true, // 添加该字段，表示进入这个路由是需要登录的
  	},
    component: OrderDetail
  },
  {
    path: '/refundDetail',
    name: 'refundDetail',
  	meta: {
  	  isLogin: true, // 添加该字段，表示进入这个路由是需要登录的
  	},
    component: RefundDetail
  },
  {
    path: '/shipTable',
    name: 'shipTable',
  	meta: {
  	  isLogin: true, // 添加该字段，表示进入这个路由是需要登录的
  	},
    component: ShipTable
  }
]

const router = new VueRouter({
  routes
})

export default router
